import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import msgbox from './plugins/msgbox.js'

Vue.prototype.$http = axios

Vue.config.productionTip = false

Vue.use(msgbox);

router.beforeEach((to, from, next) => {
	// eslint-disable-next-line
	if (_hmt) {
		if (to.path) {
			// eslint-disable-next-line
			_hmt.push(['_trackPageview', '/#' + to.fullPath]);
		}
	}
	next();
});

new Vue({
	router,
	render: h => h(App)
}).$mount('#app')
